module.exports = __webpack_public_path__ + "img/section2_img2.ad58beac.png";